import React from 'react'
import { v4 as uuid } from 'uuid'
import { useNavigate } from 'react-router-dom'
import { useTranslateContext } from '../contexts/translate.context'
import authService from '../services/auth.service'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export interface IMenuItemProps {
  name: any
  subMenus: any
  iconClassName: any
  onClick: any
  onCloseSideMenu: any
  to: any
  expanded: any
  setShowVideo: any
}

export const MenuItem: React.FC<IMenuItemProps> = (props: IMenuItemProps) => {
  const navigate = useNavigate()

  const { display } = useTranslateContext()

  function onClick_Item(event: any, link: string, isSubMenu?: boolean) {
    event.preventDefault()
    props.onCloseSideMenu(false)
    navigate(link)
  }

  const expand = (menu: any) => {
    if (menu.subMenus && menu.subMenus.length) {
      menu.expanded = menu.expanded ? menu.expanded : {}
      menu.expanded.isOpened = !menu.expanded.isOpened
    } else {
      navigate(menu.to)
    }

    return
  }

  return (
    <>
      {props.subMenus.length === 0 ? (
        <li className="sidebar-item ">
          <span
            className="sidebar-link"
            onClick={(e: any) => onClick_Item(e, props.to)}
          >
            {props.iconClassName}
            <span className="align-middle">{display.label[props.name]}</span>
          </span>
        </li>
      ) : (
        <li className="sidebar-item " onClick={props.onClick}>
          <span
            data-toggle="collapse"
            className={`sidebar-link ${
              props.expanded && !props.expanded.isOpened ? 'collapsed' : ''
            }`}
            aria-expanded={props.expanded && props.expanded.isOpened}
          >
            {props.iconClassName}
            <span className="align-middle">
              {display.menu[props.name] ? display.menu[props.name] : props.name}
            </span>
          </span>
          <div
            className={`collapse ${
              props.expanded && props.expanded.isOpened ? 'show' : ''
            }`}
          >
            {props.subMenus && props.subMenus.length > 0 ? (
              <ul id="item" className="sidebar-dropdown list-unstyled">
                {props.subMenus.map((menu: any, index: any) =>
                  !menu.divider ? (
                    menu.subMenus && menu.subMenus.length > 0 ? (
                      <li className="sidebar-item " key={uuid()}>
                        <span
                          data-toggle="collapse"
                          className={`sidebar-link ${
                            menu.expanded && !menu.expanded.isOpened
                              ? 'collapsed'
                              : ''
                          }`}
                          onClick={expand.bind(this, menu)}
                          aria-expanded={
                            menu.expanded && menu.expanded.isOpened
                          }
                        >
                          {menu.iconClassName}
                          <span className="align-middle">
                            {display.menu[menu.name] || menu.name}
                          </span>
                        </span>
                        <div
                          className={`collapse ${
                            menu.expanded && menu.expanded.isOpened
                              ? 'show'
                              : ''
                          }`}
                        >
                          <ul
                            id="item"
                            className="sidebar-dropdown list-unstyled"
                          >
                            {menu.subMenus.map((menuItem: any, indexSub: any) =>
                              !menuItem.divider ? (
                                authService.permissionIn(
                                  props.name +
                                    '_' +
                                    menu.name +
                                    '_' +
                                    menuItem.name
                                ) && (
                                  <li
                                    className="submenu sidebar-item"
                                    key={uuid()}
                                    onClick={expand.bind(this, menuItem)}
                                  >
                                    <span className="sidebar-link">
                                      {/* {menuItem.iconClassName} */}
                                      <span className="align-middle ms-5 mt-1">
                                        {display.menu[menuItem.name] ||
                                          menuItem.name}
                                      </span>
                                    </span>
                                    <div
                                      className={`collapse ${
                                        menuItem.expanded ? 'show' : ''
                                      }`}
                                    >
                                      <ul
                                        id="item"
                                        className="sidebar-dropdown list-unstyled"
                                      >
                                        {menuItem.subMenus?.map(
                                          (subMenuItem: any, indexSub: any) =>
                                            !subMenuItem.divider ? (
                                              authService.permissionIn(
                                                menu.name +
                                                  '_' +
                                                  menuItem.name +
                                                  '_' +
                                                  subMenuItem.name
                                              ) && (
                                                <li
                                                  className="sidebar-item"
                                                  key={uuid()}
                                                >
                                                  <span
                                                    className="sidebar-link"
                                                    onClick={(e: any) =>
                                                      onClick_Item(
                                                        e,
                                                        menuItem.to,
                                                        true
                                                      )
                                                    }
                                                  >
                                                    {/* {menuItem.iconClassName} */}
                                                    <span className="align-middle">
                                                      {display.menu[
                                                        menuItem.name
                                                      ] || menuItem.name}
                                                    </span>
                                                  </span>
                                                </li>
                                              )
                                            ) : (
                                              <li
                                                className="sidebar-item"
                                                key={uuid()}
                                              >
                                                <span className="sidebar-link">
                                                  <span className="sidebar-divider"></span>
                                                </span>
                                              </li>
                                            )
                                        )}
                                      </ul>
                                    </div>
                                  </li>
                                )
                              ) : (
                                <li className="sidebar-item" key={uuid()}>
                                  <span className="sidebar-link">
                                    <span className="sidebar-divider"></span>
                                  </span>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </li>
                    ) : (
                      authService.permissionIn(
                        props.name + '_' + menu.name
                      ) && (
                        <li className="sidebar-item" key={uuid()}>
                          <span
                            className="sidebar-link"
                            style={{ position: 'relative' }}
                            onClick={(e: any) => onClick_Item(e, menu.to)}
                          >
                            {menu.iconClassName}
                            <span className="align-middle">
                              {display.menu[menu.name]
                                ? display.menu[menu.name]
                                : menu.name}
                            </span>
                            {menu.video && (
                              <InfoOutlinedIcon
                                onMouseEnter={e =>
                                  props.setShowVideo({
                                    show: true,
                                    video: menu.video
                                  })
                                }
                                className="mb-1"
                                style={{ position: 'absolute', right: '0' }}
                                onMouseLeave={e =>
                                  props.setShowVideo({
                                    show: false,
                                    video: undefined
                                  })
                                }
                              >
                                i
                              </InfoOutlinedIcon>
                            )}
                          </span>
                        </li>
                      )
                    )
                  ) : (
                    <li className="sidebar-item" key={uuid()}>
                      <span className="sidebar-link">
                        <span className="sidebar-divider"></span>
                      </span>
                    </li>
                  )
                )}
              </ul>
            ) : null}
          </div>
        </li>
      )}
    </>
  )
}

